export default __webpack_public_path__ + "static/media/marinaImg1.691f4517.png";